import {
  isCognitoNoVerifiedDeliveryForPasswordResetError,
  isCognitoPasswordCannotBeResetInCurrentStateError,
  isCognitoUserAlreadyConfirmedError,
  isCognitoUserDisabledError,
  isCognitoUserNotConfirmedError,
  isCognitoUserNotFoundError,
} from '@services/cognitoErrorNormalizer';

import { SUPPORT_EMAIL } from '@shared/constants';
import { toPlainErrorObject } from '@utils/errorUtils';

export { SUPPORT_EMAIL, toPlainErrorObject };

export const getForgotPasswordServerErrorDisposition = (err) => {
  const isNotConfirmed = isCognitoUserNotConfirmedError(err);
  const isNoVerifiedDelivery = isCognitoNoVerifiedDeliveryForPasswordResetError(err);

  // "UserNotConfirmedException" is actionable here: the user can confirm their account/email.
  if (isNotConfirmed) {
    return {
      kind: 'VERIFY_EMAIL',
    };
  }

  // "No verified delivery" (no verified email/phone) cannot be resolved from Forgot Password
  // for already-confirmed users, so we route to support instead of sending them to Verify Email.
  if (isNoVerifiedDelivery) return { kind: 'HELP_POPUP' };

  const shouldShowHelpPopup =
    isCognitoUserNotFoundError(err) ||
    isCognitoUserDisabledError(err) ||
    isCognitoUserAlreadyConfirmedError(err) ||
    isCognitoPasswordCannotBeResetInCurrentStateError(err);
  if (shouldShowHelpPopup) return { kind: 'HELP_POPUP' };

  return { kind: 'INLINE_ERROR' };
};
